import React from 'react'

import ConceptItem from './ConceptItem'
import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'

const Concepts = ({ data, formData, mutations: { updateItem }, ...restProps }) => {
	const handleSubmit = vals => {
		// Some first "concept's" fields mutate also Product fields
		const mainFields = vals.dbIndex === 1 ?
			{
				...data.name !== vals.productName && { name: vals.productName },
				...data.altName !== vals.buttonCaption && { altName: vals.buttonCaption }
			}
			: {}
		const optimisticResponse = {
			cashAssist: {
				updateProduct: {
					...data,
					concepts: data.concepts.map(concept => concept.dbIndex === vals.dbIndex ? { ...concept, ...vals } : concept),
					...mainFields,
					__typename: 'Product'
				},
				__typename: 'CA_Mutation'
			},
			__typename: 'Mutation'
		}
		updateItem({ concepts: [vals], ...mainFields }, { optimisticResponse })
	}
	const { concepts = [] } = formData
	return(
		<ExpandableBlocks>
			{Array.isArray(concepts) ? concepts.map(({ name, ...conceptVals }, i) => {
				return conceptVals.dbIndex === 1 ? null :
					<ContentBlock key={conceptVals.dbIndex} startExpanded={i === 0} label={name}>
						<ConceptItem
							formData={conceptVals.dbIndex === 1 ? { ...conceptVals, productName: conceptVals.productName || data.name } : conceptVals}
							onSubmit={handleSubmit}
							{...restProps} />
					</ContentBlock>
			}) : null}
		</ExpandableBlocks>
	)
}

export default Concepts
